var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Helpers } from "survey-core";
import { ReactElementFactory } from "./element-factory";
import { ReactSurveyElementsWrapper } from "./reactsurveymodel";
var SurveyElementBase = /** @class */ (function (_super) {
    __extends(SurveyElementBase, _super);
    function SurveyElementBase(props) {
        var _this = _super.call(this, props) || this;
        _this._allowComponentUpdate = true;
        _this.prevStateElements = [];
        _this.propertyValueChangedHandler = function (stateElement, options) {
            var key = options.name;
            if (!_this.canUsePropInState(key) || _this.isRendering)
                return;
            _this.changedStatePropNameValue = key;
            _this.setState(function (state) {
                var newState = {};
                newState[key] = options.newValue;
                return newState;
            });
        };
        _this.onArrayChangedCallback = function (stateElement, options) {
            if (_this.isRendering)
                return;
            _this.changedStatePropNameValue = options.name;
            _this.setState(function (state) {
                var newState = {};
                newState[options.name] = options.newValue;
                return newState;
            });
        };
        return _this;
    }
    SurveyElementBase.renderLocString = function (locStr, style, key) {
        if (style === void 0) { style = null; }
        return ReactElementFactory.Instance.createElement(locStr.renderAs, {
            locStr: locStr.renderAsData,
            style: style,
            key: key
        });
    };
    SurveyElementBase.renderQuestionDescription = function (question) {
        var descriptionText = SurveyElementBase.renderLocString(question.locDescription);
        return React.createElement("div", { style: question.hasDescription ? undefined : { display: "none" }, id: question.ariaDescriptionId, className: question.cssDescription }, descriptionText);
    };
    SurveyElementBase.prototype.componentDidMount = function () {
        this.makeBaseElementsReact();
    };
    SurveyElementBase.prototype.componentWillUnmount = function () {
        this.unMakeBaseElementsReact();
        this.disableStateElementsRerenderEvent(this.getStateElements());
    };
    SurveyElementBase.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a;
        this.makeBaseElementsReact();
        var stateElements = this.getStateElements();
        this.disableStateElementsRerenderEvent(((_a = this.prevStateElements) !== null && _a !== void 0 ? _a : []).filter(function (el) { return !stateElements.find(function (stateElement) { return stateElement == el; }); }));
        this.prevStateElements = [];
        this.getStateElements().forEach(function (el) {
            el.afterRerender();
        });
    };
    SurveyElementBase.prototype.allowComponentUpdate = function () {
        this._allowComponentUpdate = true;
        this.forceUpdate();
    };
    SurveyElementBase.prototype.denyComponentUpdate = function () {
        this._allowComponentUpdate = false;
    };
    SurveyElementBase.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this._allowComponentUpdate) {
            this.unMakeBaseElementsReact();
            this.prevStateElements = this.getStateElements();
        }
        return this._allowComponentUpdate;
    };
    SurveyElementBase.prototype.render = function () {
        if (!this.canRender()) {
            return null;
        }
        this.startEndRendering(1);
        var res = this.renderElement();
        this.startEndRendering(-1);
        if (!!res) {
            res = this.wrapElement(res);
        }
        this.changedStatePropNameValue = undefined;
        return res;
    };
    SurveyElementBase.prototype.wrapElement = function (element) {
        return element;
    };
    Object.defineProperty(SurveyElementBase.prototype, "isRendering", {
        get: function () {
            var stateEls = this.getRenderedElements();
            for (var _i = 0, stateEls_1 = stateEls; _i < stateEls_1.length; _i++) {
                var stateEl = stateEls_1[_i];
                if (stateEl.reactRendering > 0)
                    return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    SurveyElementBase.prototype.getRenderedElements = function () {
        return this.getStateElements();
    };
    SurveyElementBase.prototype.startEndRendering = function (val) {
        var stateEls = this.getRenderedElements();
        for (var _i = 0, stateEls_2 = stateEls; _i < stateEls_2.length; _i++) {
            var stateEl = stateEls_2[_i];
            if (!stateEl.reactRendering)
                stateEl.reactRendering = 0;
            stateEl.reactRendering += val;
        }
    };
    SurveyElementBase.prototype.canRender = function () {
        return true;
    };
    SurveyElementBase.prototype.renderElement = function () {
        return null;
    };
    Object.defineProperty(SurveyElementBase.prototype, "changedStatePropName", {
        get: function () {
            return this.changedStatePropNameValue;
        },
        enumerable: false,
        configurable: true
    });
    SurveyElementBase.prototype.makeBaseElementsReact = function () {
        var els = this.getStateElements();
        for (var i = 0; i < els.length; i++) {
            els[i].enableOnElementRerenderedEvent();
            this.makeBaseElementReact(els[i]);
        }
    };
    SurveyElementBase.prototype.unMakeBaseElementsReact = function () {
        var els = this.getStateElements();
        this.unMakeBaseElementsReactive(els);
    };
    SurveyElementBase.prototype.unMakeBaseElementsReactive = function (els) {
        for (var i = 0; i < els.length; i++) {
            this.unMakeBaseElementReact(els[i]);
        }
    };
    SurveyElementBase.prototype.disableStateElementsRerenderEvent = function (els) {
        els.forEach(function (el) {
            el.disableOnElementRerenderedEvent();
        });
    };
    SurveyElementBase.prototype.getStateElements = function () {
        var el = this.getStateElement();
        return !!el ? [el] : [];
    };
    SurveyElementBase.prototype.getStateElement = function () {
        return null;
    };
    Object.defineProperty(SurveyElementBase.prototype, "isDisplayMode", {
        get: function () {
            var props = this.props;
            return props.isDisplayMode || false;
        },
        enumerable: false,
        configurable: true
    });
    SurveyElementBase.prototype.renderLocString = function (locStr, style, key) {
        if (style === void 0) { style = null; }
        return SurveyElementBase.renderLocString(locStr, style, key);
    };
    SurveyElementBase.prototype.canMakeReact = function (stateElement) {
        return !!stateElement && !!stateElement.iteratePropertiesHash;
    };
    SurveyElementBase.prototype.makeBaseElementReact = function (stateElement) {
        if (!this.canMakeReact(stateElement))
            return;
        stateElement.addOnArrayChangedCallback(this.onArrayChangedCallback);
        stateElement.addOnPropertyValueChangedCallback(this.propertyValueChangedHandler);
    };
    SurveyElementBase.prototype.canUsePropInState = function (key) {
        return true;
    };
    SurveyElementBase.prototype.unMakeBaseElementReact = function (stateElement) {
        if (!this.canMakeReact(stateElement))
            return;
        stateElement.removeOnPropertyValueChangedCallback(this.propertyValueChangedHandler);
        stateElement.removeOnArrayChangedCallback(this.onArrayChangedCallback);
    };
    return SurveyElementBase;
}(React.Component));
export { SurveyElementBase };
var ReactSurveyElement = /** @class */ (function (_super) {
    __extends(ReactSurveyElement, _super);
    function ReactSurveyElement(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(ReactSurveyElement.prototype, "cssClasses", {
        get: function () {
            return this.props.cssClasses;
        },
        enumerable: false,
        configurable: true
    });
    return ReactSurveyElement;
}(SurveyElementBase));
export { ReactSurveyElement };
var SurveyQuestionElementBase = /** @class */ (function (_super) {
    __extends(SurveyQuestionElementBase, _super);
    function SurveyQuestionElementBase(props) {
        return _super.call(this, props) || this;
    }
    SurveyQuestionElementBase.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.updateDomElement();
    };
    SurveyQuestionElementBase.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.updateDomElement();
    };
    SurveyQuestionElementBase.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        if (!!this.questionBase) {
            var contentElement = this.content || this.control;
            this.questionBase.beforeDestroyQuestionElement(contentElement);
            if (!!contentElement) {
                contentElement.removeAttribute("data-rendered");
            }
        }
    };
    SurveyQuestionElementBase.prototype.updateDomElement = function () {
        var contentElement = this.content || this.control;
        if (!!contentElement) {
            if (contentElement.getAttribute("data-rendered") !== "r") {
                contentElement.setAttribute("data-rendered", "r");
                this.questionBase.afterRenderQuestionElement(contentElement);
            }
        }
    };
    Object.defineProperty(SurveyQuestionElementBase.prototype, "questionBase", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionElementBase.prototype.getRenderedElements = function () {
        return [this.questionBase];
    };
    Object.defineProperty(SurveyQuestionElementBase.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionElementBase.prototype.canRender = function () {
        return !!this.questionBase && !!this.creator;
    };
    SurveyQuestionElementBase.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (!_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState))
            return false;
        return (!this.questionBase.customWidget ||
            !!this.questionBase.customWidgetData.isNeedRender ||
            !!this.questionBase.customWidget.widgetJson.isDefaultRender ||
            !!this.questionBase.customWidget.widgetJson.render);
    };
    Object.defineProperty(SurveyQuestionElementBase.prototype, "isDisplayMode", {
        get: function () {
            var props = this.props;
            return (props.isDisplayMode ||
                (!!this.questionBase && this.questionBase.isInputReadOnly) || false);
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionElementBase.prototype.wrapCell = function (cell, element, reason) {
        if (!reason) {
            return element;
        }
        var survey = this.questionBase
            .survey;
        var wrapper = null;
        if (survey) {
            wrapper = ReactSurveyElementsWrapper.wrapMatrixCell(survey, element, cell, reason);
        }
        return wrapper !== null && wrapper !== void 0 ? wrapper : element;
    };
    SurveyQuestionElementBase.prototype.setControl = function (element) {
        if (!!element) {
            this.control = element;
        }
    };
    SurveyQuestionElementBase.prototype.setContent = function (element) {
        if (!!element) {
            this.content = element;
        }
    };
    return SurveyQuestionElementBase;
}(SurveyElementBase));
export { SurveyQuestionElementBase };
var SurveyQuestionUncontrolledElement = /** @class */ (function (_super) {
    __extends(SurveyQuestionUncontrolledElement, _super);
    function SurveyQuestionUncontrolledElement(props) {
        var _this = _super.call(this, props) || this;
        _this.updateValueOnEvent = function (event) {
            if (!Helpers.isTwoValueEquals(_this.questionBase.value, event.target.value, false, true, false)) {
                _this.setValueCore(event.target.value);
            }
        };
        _this.updateValueOnEvent = _this.updateValueOnEvent.bind(_this);
        return _this;
    }
    Object.defineProperty(SurveyQuestionUncontrolledElement.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionUncontrolledElement.prototype.setValueCore = function (newValue) {
        this.questionBase.value = newValue;
    };
    SurveyQuestionUncontrolledElement.prototype.getValueCore = function () {
        return this.questionBase.value;
    };
    SurveyQuestionUncontrolledElement.prototype.updateDomElement = function () {
        if (!!this.control) {
            var control = this.control;
            var newValue = this.getValueCore();
            if (!Helpers.isTwoValueEquals(newValue, control.value, false, true, false)) {
                control.value = this.getValue(newValue);
            }
        }
        _super.prototype.updateDomElement.call(this);
    };
    SurveyQuestionUncontrolledElement.prototype.getValue = function (val) {
        if (Helpers.isValueEmpty(val))
            return "";
        return val;
    };
    return SurveyQuestionUncontrolledElement;
}(SurveyQuestionElementBase));
export { SurveyQuestionUncontrolledElement };
